module.exports = __webpack_public_path__ + "img/arrow-button.5b9c01b0.png";